import dayjs from 'dayjs';

import { ResizeDirection } from '@/modules/planner';

export const hexToRGBA = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * Checks whether resize should be disabled on a specific side of a weekend-split assignment fragment.
 * Resize is only enabled on the fragment whose edge matches the original assignment's effective edge.
 */
export const isFragmentResizeDisabled = (
  fragmentDate: dayjs.Dayjs,
  originalDate: string,
  direction: ResizeDirection
): boolean => {
  const effectiveDate = snapToWeekday(dayjs(originalDate), direction);
  return !effectiveDate.isSame(fragmentDate, 'day');
};

/**
 * Snaps a weekend date to the nearest weekday.
 * Sunday → Monday (+1), Saturday → next direction depends on usage.
 * @param date - The date to adjust
 * @param direction - 'forward' snaps to the next weekday, 'backward' snaps to the previous weekday
 */
const snapToWeekday = (date: dayjs.Dayjs, direction: ResizeDirection): dayjs.Dayjs => {
  const day = date.day();
  if (day === 0) return date.add(direction === ResizeDirection.Forward ? 1 : -2, 'day');
  if (day === 6) return date.add(direction === ResizeDirection.Forward ? 2 : -1, 'day');
  return date;
};
